module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ce6e50c9f7f1d7d4a4f51fd01993a2ce.png";